import Image from 'next/image'
import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import Container from '@comp/ui/container'
import Text from '@comp/ui/text'

const logos = [
  { src: '/images/logos/ziraat-bankasi-logo.svg', alt: 'Ziraat Bankası', width: 131, height: 29 },
  { src: '/images/logos/iga-istanbul-logo.svg', alt: 'IGA Istanbul Airport', width: 129, height: 21 },
  { src: '/images/logos/mcdonalds.svg', alt: "McDonald's", width: 43, height: 39 },
  { src: '/images/logos/stc.svg', alt: 'Saudi Telecom Company', width: 65, height: 33 },
  { src: '/images/logos/odeabank.svg', alt: 'Odeabank', width: 94, height: 19 },
  { src: '/images/logos/godiva-logo.svg', alt: 'Godiva', width: 54, height: 39 },
  { src: '/images/logos/united-biscuits.svg', alt: 'United Biscuits', width: 42, height: 35 },
  { src: '/images/logos/fener-logo.svg', alt: 'Fenerbahçe Sports Club', width: 44, height: 43 },
]

const stats = [
  { label: { en: 'identities secured', tr: 'g\u00fcvence alt\u0131ndaki kimlik' }, value: '50M+' },
  { label: { en: 'enterprise integrations', tr: 'kurumsal entegrasyon' }, value: '7,000+' },
  { label: { en: 'countries', tr: '\u00fclke' }, value: '40+' },
]

const heading = {
  en: 'Trusted by enterprises worldwide',
  tr: 'D\u00fcnya genelinde kurumsal \u015firketlerin tercihi',
}

export default function TrustBand() {
  const { locale } = useRouter()
  const lang = locale === 'tr' ? 'tr' : 'en'
  return (
    <section className="border-y border-line-subtle bg-surface-subtle py-14 lg:py-20" data-density="compact">
      <Container size="xl">
        <div className="flex flex-col items-center gap-10 lg:flex-row lg:items-start lg:justify-between lg:gap-16">
          <div className="max-w-sm text-center lg:text-left">
            <Text size="sm" tone="tertiary" className="uppercase tracking-[0.14em] font-semibold">
              {heading[lang]}
            </Text>
            <div className="mt-6 flex flex-wrap justify-center gap-x-10 gap-y-4 lg:justify-start">
              {stats.map((s) => (
                <div key={s.label.en}>
                  <div className="text-display-sm font-medium text-ink-primary tabular-nums">
                    {s.value}
                  </div>
                  <Text size="sm" tone="tertiary" className="mt-1">
                    {s.label[lang]}
                  </Text>
                </div>
              ))}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.45 }}
            className="grid w-full max-w-3xl grid-cols-2 items-center gap-x-10 gap-y-8 sm:grid-cols-4"
          >
            {logos.map((logo) => (
              <div
                key={logo.alt}
                className="flex h-10 items-center justify-center brightness-50 transition duration-200 ease-smooth hover:brightness-0"
              >
                <Image
                  src={logo.src}
                  alt={logo.alt}
                  width={logo.width}
                  height={logo.height}
                />
              </div>
            ))}
          </motion.div>
        </div>
      </Container>
    </section>
  )
}
